import React, { Component } from 'react';

import AsideView from '@uicomponents/AsideView';
import Loader from '@uicomponents/Loader';

import Vehicle from '@models/vehicle/Vehicle';

import VehicleForm from './VehicleForm';

export default class CreateVehiclePage extends Component {
  componentDidMount() {
    const { onChange } = this.props;
    onChange('formVehicle', new Vehicle());
  }

  render() {
    const { t, formVehicle, isFetchingVehicle, createVehicle } = this.props;

    if (!formVehicle || isFetchingVehicle) {
      return (
        <div className="absolute-center">
          <Loader />
        </div>
      );
    }

    return (
      <AsideView>
        <h1>{t('vehicle.new')}</h1>
        <VehicleForm
          {...this.props}
          key={formVehicle.id}
          onSubmit={(vehicle) => createVehicle(vehicle)}
        />
      </AsideView>
    );
  }
}
